import React from "react";
import Caret from "../Caret/Caret";
import "./TextInputForSelect.css";

class TextInputForSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div
        className={this.props.menuIsOpen ? "input input-open" : "input"}
        onClick={(e) => this.props.handleInputClick(e)}
      >
        {this.props.label ? <label htmlFor={this.props.inputId}></label> : null}
        <input
          key={this.props.key}
          type="text"
          readOnly={this.props.readOnly}
          value={this.props.value}
          placeholder={this.props.placeholder}
          onChange={this.props.onChange}
          defaultValue={this.props.defaultValue}
          name={this.props.name}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
          }}
          id={this.props.inputId}
        />
        <Caret />
      </div>
    );
  }
}

export default TextInputForSelect;

// const TextInputForSelect = (props) => {
//     return (

//      );
// }

// export default TextInputForSelect;
